import styles from './Loader.module.scss';

interface LoaderProps {
  size?: number;
  color?: string;
  text?: string;
}

export const Loader: React.FC<LoaderProps> = ({ size = 20, color, text }) => {
  const loaderStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderTopColor: color,
  };

  return (
    <div
      data-testid="loader"
      className={styles.loader__wrapper}
    >
      <div
        className={styles.loader}
        style={loaderStyle}
      ></div>
      <span>{text}</span>
    </div>
  );
};
